import styled from 'styled-components';

export interface ContainerProps {
  $disabled?: boolean;
}

interface ValueProps {
  active: boolean;
}

export const Container = styled.section<ContainerProps>`
  background: ${({ theme, $disabled }) =>
    $disabled ? theme.searchInput.date.disabled.background : theme.searchInput.date.background};
  color: ${({ theme, $disabled }) =>
    $disabled ? theme.searchInput.date.disabled.label.color : theme.searchInput.date.label.color};
  border: 2px solid #b8b4b4;

  max-width: 100%;
  overflow: hidden;
  padding: 10px 16px;
  position: relative;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;

  * > span {
    ${({ $disabled }) => ($disabled ? 'color: #b8b4b4;' : '')}
  }
`;

export const Content = styled.button`
  flex: 1;
  cursor: pointer;
  background: none;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Label = styled.span`
  position: absolute;
  top: ${({ theme }) => theme.searchInput.date.detail.top};

  font-size: ${({ theme }) => theme.searchInput.date.detail.fontSize};
  line-height: 1.2em;
  color: ${({ theme }) => theme.searchInput.date.detail.color};
`;

export const Value = styled.span<ValueProps>`
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.5em;
  color: ${({ theme, active }) =>
    active ? theme.searchInput.date.label.color : theme.searchInput.date.placeholder.label.color};
  font-weight: ${({ active }) => (active ? '600' : 'normal')};
  margin-top: 19px;
  margin-right: 8px;
`;
